import { render, staticRenderFns } from "./DesignersByProductTemplate.vue?vue&type=template&id=995b5dd4&"
import script from "./DesignersByProductTemplate.vue?vue&type=script&lang=js&"
export * from "./DesignersByProductTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports